import { Component, OnInit } from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";
import { MatDialog } from "@angular/material/dialog";
import { PreviewContentComponent } from "../preview-content/preview-content.component";

import { MarkdownService } from "../../services/markdown/markdown.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { PortalAdminService } from "../../services/portal-admin-service/portal-adimin.service";
import { SpecialProgramMarkdown } from "../../models/specialProgram-markdown";
import { SpecialProgramUpdate } from "../../models/specialProgram-update";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";

@Component({
    selector: "pa-edit-content",
    animations: [
        trigger("openClose", [
            state("open", style({
                height: "55vh",
                width: "100%",
                opacity: 1,
            })),
            state("closed", style({
                height: "0px",
                opacity: 0.5,
            })),
            transition("open => closed", [animate(".25s")]),
            transition("closed => open", [animate("0.25s")]),
        ]),
    ],
    templateUrl: "./edit-content.component.html",
    styleUrls: ["./edit-content.component.scss"],
    standalone: false
})
export class EditContentComponent implements OnInit {
  preview = false;
  isLoadingResults = false;
  defaultYear = new Date().getFullYear();
  selectedYear: number;
  isLoading: boolean;
  displayedMarkdown: string;
  displayedDescription: string;
  selectedProgram: string;
  selectedProgramCode = "bdf";
  selectedSpProgram = "";
  selectedSpCountry = null;

  previousYear = new Date().getFullYear() - 1;
  currentYear = new Date().getFullYear();
  nextYear = new Date().getFullYear() + 1;

  isOpen = false;

  constructor(
    private portalAdminService: PortalAdminService,
    public dialog: MatDialog,
    private markdownService: MarkdownService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.selectedYear = this.defaultYear;
    this.portalAdminService
      .getProgramMarkdown(
        this.selectedProgramCode,
        this.selectedYear,
        this.selectedSpProgram,
        this.selectedSpCountry
      )
      .subscribe(
        (programRes: SpecialProgramMarkdown) => {
          this.displayedMarkdown = programRes.details;
          this.displayedDescription = programRes.toolTip;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(err);
          if (err.status === 403 || err.status === 401) {
            this.router.navigate(["/access-denied"]);
          } else {
            this.router.navigate(["/error"]);
          }
        }
      );
  }

  selectProgram(programCode: string, program: string, country: string = null) {
    this.isLoading = true;
    this.selectedProgramCode = programCode;
    this.selectedSpProgram = program;
    this.selectedSpCountry = country;
    this.portalAdminService
      .getProgramMarkdown(programCode, this.selectedYear, program, country)
      .subscribe(
        (programRes: SpecialProgramMarkdown) => {
          this.displayedMarkdown = programRes.details;
          this.displayedDescription = programRes.toolTip;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(err);
          if (err.status === 403 || err.status === 401) {
            this.router.navigate(["/access-denied"]);
          } else {
            this.router.navigate(["/error"]);
          }
        }
      );
  }

  selectYear(event: MatButtonToggleChange) {
    this.isLoading = true;
    this.selectedYear = event.value;
    this.portalAdminService
      .getProgramMarkdown(
        this.selectedProgramCode,
        this.selectedYear,
        this.selectedSpProgram,
        this.selectedSpCountry
      )
      .subscribe(
        (programRes: SpecialProgramMarkdown) => {
          this.displayedMarkdown = programRes.details;
          this.displayedDescription = programRes.toolTip;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(err);
          if (err.status === 403 || err.status === 401) {
            this.router.navigate(["/access-denied"]);
          } else {
            this.router.navigate(["/error"]);
          }
        }
      );
  }

  updateMarkdown() {
    this.isLoading = true;
    const updateObj: SpecialProgramUpdate = {
      name: "",
      code: this.selectedProgramCode,
      toolTip: this.displayedDescription,
      program: this.selectedSpProgram,
      country: this.selectedSpCountry,
      year: this.selectedYear,
      details: this.displayedMarkdown,
    };
    this.portalAdminService.updateProgramMarkdown(updateObj).subscribe(
      (updateRes) => {
        this.isLoading = false;
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.log(err);
        if (err.status === 403 || err.status === 401) {
          this.router.navigate(["/access-denied"]);
        } else {
          this.router.navigate(["/error"]);
        }
      }
    );
  }

  openPreview() {
    const markdown = this.markdownService.compile(
      this.displayedMarkdown.replace(new RegExp("@@hr@@", "g"), "<hr />")
    );
    const dialogRef = this.dialog.open(PreviewContentComponent, {
      // height: '460px',
      width: "960px",
      data: { html: markdown },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // console.log('The dialog was closed', result);
    });
  }

  closePreview() {
    this.preview = false;
    this.isLoadingResults = false;
  }

  toggleLegend() {
    this.isOpen = !this.isOpen;
  }
}
